import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { loginUser } from '../../../store/actions';
import config from '../../../constants/settings';
import { Permissions } from '../../../constants/enums';

const LoginButton = () => {
  const { isAuthenticated, loginWithRedirect, isLoading, getAccessTokenSilently } = useAuth0();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data,
      lastPath: Login.lastPath,
    })
  );

  const { token, lastPath, data } = useSelector(LoginProperties);
  const userInfo = data?.data || { permissions: [] };

  const fetchUserMetadata = async () => {
    try {
      const accessToken = await getAccessTokenSilently({
        authorizationParams: {
          audience: config.auth0.audience,
          scope: "read:current_user offline_access",
        },
      });
      dispatch(loginUser(accessToken, navigate));
    } catch (e) {
      console.error("Error - fetchUserMetadata - ", e.message);
    }
  };

  useEffect(() => {
    if (!isAuthenticated) return;

    if (!token) {
      fetchUserMetadata();
      return;
    }

    if (location.pathname === '/login' || location.pathname === '/') {
      if (lastPath && lastPath !== '/') {
        navigate(lastPath);
      } else {
        const paths = {
          [Permissions.DRIVER_READ]: '/services/request',
          [Permissions.USERS_READ]: '/users',
          [Permissions.EMPLOYEES_READ]: '/employees',
          [Permissions.COST_CENTER_READ]: '/cost-centers',
        };

        for (const [permission, path] of Object.entries(paths)) {
          if (userInfo.permissions?.includes(permission)) {
            navigate(path);
            break;
          }
        }
      }
    }
  }, [
    isAuthenticated,
    token,
    lastPath,
    userInfo.permissions,
    location.pathname,
    navigate,
    getAccessTokenSilently,
    dispatch,
  ]);

  if (isLoading) {
    return (
      <div className="text-center">
        <div role="status" className="ms-2 spinner-border text-danger">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    !isAuthenticated && (
      <button
        className="btn btn-primary btn-block"
        type="button"
        onClick={() =>
          loginWithRedirect({
            appState: { returnTo: location.pathname + location.search },
            authorizationParams: {
              redirect_uri: window.location.origin,
            },
          })
        }
      >
        Iniciar Sesión
      </button>
    )
  );
};

export default LoginButton;
